import { throttle, flatten, map } from 'lodash';
import $ from 'jquery'
import PubSub from 'pubsub-js';

const FADE_BASE_CLASS ='scroll-fade'
const FADE_IN_CLASS= `${FADE_BASE_CLASS}--in`
const FADE_OUT_CLASS= `${FADE_BASE_CLASS}--out`
const THRESHOLD = 200
const $window = $(window)

function ContentElement(el) {
  this.$element = $(el);

  if (this.$element.offset().top > $window.scrollTop() + $window.height()) {
    this.$element.addClass(`${FADE_BASE_CLASS} ${FADE_OUT_CLASS}`);
  }

  PubSub.subscribe('page/scroll', this.scrollHandler.bind(this));
}

ContentElement.prototype.scrollHandler = function (event, windowTop) {
  if (this.$element.hasClass(FADE_IN_CLASS)) {
    return;
  }

  if (this.$element.offset().top <= windowTop + $window.height() - THRESHOLD) {
    this.$element.removeClass(FADE_OUT_CLASS).addClass(FADE_IN_CLASS);
  }
};

const scrollHandler = () => {
  let top = $window.scrollTop();

  if (typeof top !== 'number') {
    top = 0;
  }

  PubSub.publish('page/scroll', $window.scrollTop());
};

document.addEventListener('DOMContentLoaded', () => {
  let main = [].slice.call(document.querySelectorAll('.main'));
  let selector = '[data-scroll-fade], .scroll-fade';

  let elements = flatten(map(main, m => {
    return [].slice.call(m.querySelectorAll(selector));
  }));

  elements.forEach((element) => new ContentElement(element));

  // Run the scrollHandler initially to make sure that any elements
  // that should already be visible are shown automatically.
  scrollHandler();
});

$window.on('load', scrollHandler);
$window.on('scroll', throttle(scrollHandler, 20));



// WEBPACK FOOTER //
// ./scripts/lib/scroll-fade.js